const objectives = [
  { name: '', label: 'Select a campaign objective' },
  { name: 'OUTCOME_LEADS', label: 'Leads' },
  { name: 'OUTCOME_SALES', label: 'Sales' },
  { name: 'OUTCOME_ENGAGEMENT', label: 'Engagement' },
  { name: 'OUTCOME_AWARENESS', label: 'Awareness' },
  { name: 'OUTCOME_TRAFFIC', label: 'Traffic' },
  { name: 'OUTCOME_APP_PROMOTION', label: 'App Promotion' },
]

export default objectives;
